import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
  gap: 24px;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;
const Summary = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
`;
const SummaryRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 500;
  color: #222;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
`;
const SummaryLabel = styled.span`
  width: 75px;
  color: #616161;
`;

const AppraisalPriceSummary = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
`;

const ATableTitle = styled.div`
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

interface ATableProps {
  isHeader: boolean;
}
const ATableContent = styled.div<ATableProps>`
  color: ${({ isHeader }) => (isHeader ? '#222222' : '#616161')};
  font-size: ${({ isHeader }) => (isHeader ? '16px' : '14px')};
  font-weight: ${({ isHeader }) => (isHeader ? '700' : '500')};
  line-height: ${({ isHeader }) => (isHeader ? '23.2px' : '20.3px')};
  margin-top: ${({ isHeader }) => (isHeader ? '24px' : '0px')};
  white-space: pre-line;
  letter-spacing: -0.36px;
`;

const BlockTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const BlockTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
  color: #222;
`;

export const s = {
  Container,
  Block,
  Title,
  Summary,
  SummaryRow,
  SummaryLabel,
  AppraisalPriceSummary,
  ATableTitle,
  ATableContent,
  BlockTitleBox,
  BlockTitle,
};

const PContainer = styled.div`
  width: 100%;
  padding: 32px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #fff;
  font-family: Spoqa Han Sans Neo;
`;



const PSummaryLabel = styled.div`
  width: 90px;
  color: #616161;
`;
export const p = {
  PContainer,
  PSummaryLabel,
};
